import { render } from "./RecommendInfo.vue?vue&type=template&id=71275ec7&scoped=true"
import script from "./RecommendInfo.vue?vue&type=script&lang=js"
export * from "./RecommendInfo.vue?vue&type=script&lang=js"

import "./RecommendInfo.vue?vue&type=style&index=0&id=71275ec7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71275ec7"]])

export default __exports__